<template lang="pug">
  main
    NavBarAccesos
    Loader(v-show="isLoading")
    section.section(v-show="!isLoading")
      .container
        h3.title Lista de Verificación para Carga de Gas LP de Autotanques
          | &nbsp
          router-link.a.button.is-dark.is-rounded.is-size-6.is-medium(to="/TPA/SCA/Accesos")
            i.fas.fa-times
        .columns
          .column.is-12
            .container
              .content
                .columns
                  .column
                    .card
                      header.card-header
                        p.card-header-title Autotanque {{ tanqueActualSel.pg }}
                      .card-content
                        .content
                          .columns
                            .column.is-10
                              p 
                                span.tag.is-danger 1 
                                |  ¿Él operador presenta condiciones físicas aceptables (vista, coordinación, sin aliento alcohólico o bajo la influencia de alguna droga)?
                            .column.is-2
                              .field
                                input#p1y.is-checkradio.is-danger(type='radio', value='1' v-model='p1' checked='checked')
                                label.is-size-6(for='p1y') Si
                                input#p1n.is-checkradio.is-danger(type='radio', value='0' v-model='p1')
                                label.is-size-6(for='p1n') No
                          .columns
                            .column.is-10
                              p 
                                span.tag.is-danger 2 
                                |  Ropa de algodón (Overol obligatorio) casco de seguridad, lentes de seguridad y guantes de carnaza.
                            .column.is-2
                              .field
                                input#p2y.is-checkradio.is-danger(type='radio', value='1' v-model='p2' checked='checked')
                                label.is-size-6(for='p2y') Si
                                input#p2n.is-checkradio.is-danger(type='radio', value='0' v-model='p2')
                                label.is-size-6(for='p2n') No
                          .columns
                            .column.is-10
                              p 
                                span.tag.is-danger 3 
                                |  Constancia de embarque anterior, por autotanque (Forma PEMEX 3-218-7 copia 1)
                            .column.is-2
                              .field
                                input#p3y.is-checkradio.is-danger(type='radio', value='1' v-model='p3' checked='checked')
                                label.is-size-6(for='p3y') Si
                                input#p3n.is-checkradio.is-danger(type='radio', value='0' v-model='p3')
                                label.is-size-6(for='p3n') No
                          .columns
                            .column.is-10
                              p 
                                span.tag.is-danger 4 
                                |  Licencia Federal para el Transporte de Materiales Peligrosos Tipo "E" Vigente.
                            .column.is-2
                              .field
                                input#p4y.is-checkradio.is-danger(type='radio', value='1' v-model='p4' checked='checked')
                                label.is-size-6(for='p4y') Si
                                input#p4n.is-checkradio.is-danger(type='radio', value='0' v-model='p4')
                                label.is-size-6(for='p4n') No
                          .columns
                            .column.is-10
                              p 
                                span.tag.is-warning 5 
                                |  ¿Porta identificación Oficial de la Empresa?
                            .column.is-2
                              .field
                                input#p5y.is-checkradio.is-warning(type='radio', value='1' v-model='p5' checked='checked')
                                label.is-size-6(for='p5y') Si
                                input#p5n.is-checkradio.is-warning(type='radio', value='0' v-model='p5')
                                label.is-size-6(for='p5n') No
                          .columns
                            .column.is-10
                              p 
                                span.tag.is-warning 6 
                                |  Hoja de emergencia del producto.
                            .column.is-2
                              .field
                                input#p6y.is-checkradio.is-warning(type='radio', value='1' v-model='p6' checked='checked')
                                label.is-size-6(for='p6y') Si
                                input#p6n.is-checkradio.is-warning(type='radio', value='0' v-model='p6')
                                label.is-size-6(for='p6n') No
                          .columns
                            .column.is-10
                              p 
                                span.tag.is-warning 7 
                                |  Tarjeta de circulación del tractor y tanque(s) y permiso de la SCT para el transporte de materiales peligrosos.
                            .column.is-2
                              .field
                                input#p7y.is-checkradio.is-warning(type='radio', value='1' v-model='p7', checked='checked')
                                label.is-size-6(for='p7y') Si
                                input#p7n.is-checkradio.is-warning(type='radio', value='0' v-model='p7')
                                label.is-size-6(for='p7n') No
                          .columns
                            .column.is-10
                              p 
                                span.tag.is-danger 8 
                                |  Póliza de seguro vigente que ampara daños a terceros.
                            .column.is-2
                              .field
                                input#p8y.is-checkradio.is-danger(type='radio', value='1' v-model='p8', checked='checked')
                                label.is-size-6(for='p8y') Si
                                input#p8n.is-checkradio.is-danger(type='radio', value='0' v-model='p8')
                                label.is-size-6(for='p8n') No
                          .columns
                            .column.is-10
                              p 
                                span.tag.is-danger 9 
                                |  Póliza de seguro vigente que ampara daños a al medio ambiente.
                            .column.is-2
                              .field
                                input#p9y.is-checkradio.is-danger(type='radio', value='1' v-model='p9' checked='checked')
                                label.is-size-6(for='p9y') Si
                                input#p9n.is-checkradio.is-danger(type='radio', value='0' v-model='p9')
                                label.is-size-6(for='p9n') No
                          .columns
                            .column.is-10
                              p 
                                span.tag.is-danger 10 
                                |  Revisión de cabina para evitar introducción de acompañantes u objetos de dudosa procedencia.
                            .column.is-2
                              .field
                                input#p10y.is-checkradio.is-danger(type='radio', value='1' v-model='p10' checked='checked')
                                label.is-size-6(for='p10y') Si
                                input#p10n.is-checkradio.is-danger(type='radio', value='0' v-model='p10')
                                label.is-size-6(for='p10n') No
                          .columns
                            .column.is-10
                              p 
                                span.tag.is-danger 11 
                                |  Presión de 2.5 a 3.5 kg/cm² y nivel del tanque al 0% (Indicador tipo magnatel).
                            .column.is-2
                              .field
                                input#p11y.is-checkradio.is-danger(type='radio', value='1' v-model='p11' checked='checked')
                                label.is-size-6(for='p11y') Si
                                input#p11n.is-checkradio.is-danger(type='radio', value='0' v-model='p11')
                                label.is-size-6(for='p11n') No
                          .columns
                            .column.is-10
                              p 
                                span.tag.is-danger 12 
                                |  Escape(s) y matachispas en buen estado.
                            .column.is-2
                              .field
                                input#p12y.is-checkradio.is-danger(type='radio', value='1' v-model='p12' checked='checked')
                                label.is-size-6(for='p12y') Si
                                input#p12n.is-checkradio.is-danger(type='radio', value='0' v-model='p12')
                                label.is-size-6(for='p12n') No
                          .columns
                            .column.is-10
                              p 
                                span.tag.is-danger 13 
                                |  Extintor cargado y vigente (Polvo químico seco Tipo A B C de 9 kg.).
                            .column.is-2
                              .field
                                input#p13y.is-checkradio.is-danger(type='radio', value='1' v-model='p13' checked='checked')
                                label.is-size-6(for='p13y') Si
                                input#p13n.is-checkradio.is-danger(type='radio', value='0' v-model='p13')
                                label.is-size-6(for='p13n') No
                          .columns
                            .column.is-10
                              p 
                                span.tag.is-danger 14 
                                |  Conector de tierra de tanque (Limpio y sin pintura).
                            .column.is-2
                              .field
                                input#p14y.is-checkradio.is-danger(type='radio', value='1' v-model='p14' checked='checked')
                                label.is-size-6(for='p14y') Si
                                input#p14n.is-checkradio.is-danger(type='radio', value='0' v-model='p14')
                                label.is-size-6(for='p14n') No
                          .columns
                            .column.is-10
                              p 
                                span.tag.is-danger 15 
                                |  Cinta estática a tierra en tractor y tanque.
                            .column.is-2
                              .field
                                input#p15y.is-checkradio.is-danger(type='radio', value='1' v-model='p15' checked='checked')
                                label.is-size-6(for='p15y') Si
                                input#p15n.is-checkradio.is-danger(type='radio', value='0' v-model='p15')
                                label.is-size-6(for='p15n') No
                          .columns
                            .column.is-10
                              p 
                                span.tag.is-danger 16 
                                |  Válvulas de Fondo, conector hermético y líneas de desfogue en buen estado con tapas y sin fugas (Arreglo "T" con conector hermético).
                            .column.is-2
                              .field
                                input#p16y.is-checkradio.is-danger(type='radio', value='1' v-model='p16' checked='checked')
                                label.is-size-6(for='p16y') Si
                                input#p16n.is-checkradio.is-danger(type='radio', value='0' v-model='p16')
                                label.is-size-6(for='p16n') No
                          .columns
                            .column.is-10
                              p 
                                span.tag.is-danger 17 
                                |  Sistema eléctrico (Cables dentro de ductos y tapas de condulets instaladas en micas en buen estado).
                            .column.is-2
                              .field
                                input#p17y.is-checkradio.is-danger(type='radio', value='1' v-model='p17' checked='checked')
                                label.is-size-6(for='p17y') Si
                                input#p17n.is-checkradio.is-danger(type='radio', value='0' v-model='p17')
                                label.is-size-6(for='p17n') No
                          .columns
                            .column.is-10
                              p 
                                span.tag.is-danger 18 
                                |  Llantas en buen estado.
                            .column.is-2
                              .field
                                input#p18y.is-checkradio.is-danger(type='radio', value='1' v-model='p18' checked='checked')
                                label.is-size-6(for='p18y') Si
                                input#p18n.is-checkradio.is-danger(type='radio', value='0' v-model='p18')
                                label.is-size-6(for='p18n') No
                          .columns
                            .column.is-10
                              p 
                                span.tag.is-danger 19 
                                |  Llave de bronce.
                            .column.is-2
                              .field
                                input#p19y.is-checkradio.is-danger(type='radio', value='1' v-model='p19' checked='checked')
                                label.is-size-6(for='p19y') Si
                                input#p19n.is-checkradio.is-danger(type='radio', value='0' v-model='p19')
                                label.is-size-6(for='p19n') No
                          .columns
                            .column.is-10
                              p 
                                span.tag.is-danger 20 
                                |  El tanque y patines presenta: golpes, corrosión severa y/o abolladuras evidentes.
                            .column.is-2
                              .field
                                input#p20y.is-checkradio.is-danger(type='radio', value='1' v-model='p20')
                                label.is-size-6(for='p20y') Si
                                input#p20n.is-checkradio.is-danger(type='radio', value='0' v-model='p20' checked='checked')
                                label.is-size-6(for='p20n') No
                          .columns
                            .column.is-10
                              p 
                                span.tag.is-danger 21 
                                |  Cuenta con banderolas.
                            .column.is-2
                              .field
                                input#p21y.is-checkradio.is-danger(type='radio', value='1' v-model='p21')
                                label.is-size-6(for='p21y') Si
                                input#p21n.is-checkradio.is-danger(type='radio', value='0' v-model='p21')
                                label.is-size-6(for='p21n') No
                          .columns
                            .column.is-10
                              p 
                                span.tag.is-warning 22 
                                |  Dictamen vigente de cumplimiento con la presente Norma Oficial Mexicana (NOM-007-SESH-2010) salvo en los casos que se trate de la primera evaluación de la conformidad del vehículo.
                            .column.is-2
                              .field
                                input#p22y.is-checkradio.is-warning(type='radio', value='1' v-model='p22' checked='checked')
                                label.is-size-6(for='p22y') Si
                                input#p22n.is-checkradio.is-warning(type='radio', value='0' v-model='p22')
                                label.is-size-6(for='p22n') No
                          .columns
                            .column.is-10
                              p 
                                span.tag.is-warning 23 
                                |  Copia del escrito de relación del parque vehicular presentado ante la secretaría de energía donde se encuentre incluido el vehículo a evaluar, salvo que se trate de la primera evaluación hecha al mismo previo a su inicio de operaciones.
                            .column.is-2
                              .field
                                input#p23y.is-checkradio.is-warning(type='radio', value='1' v-model='p23' checked='checked')
                                label.is-size-6(for='p23y') Si
                                input#p23n.is-checkradio.is-warning(type='radio', value='0' v-model='p23')
                                label.is-size-6(for='p23n') No
                          .columns
                            .column.is-6
                              .control
                                .field.is-horizontal
                                  .field-label.is-normal
                                    label.label Observaciones:
                                  .field-body
                                    .field
                                      p.control
                                        textarea.textarea.has-fixed-size(placeholder='Observaciones' v-model="observaciones")
                              
                            .column.is-4
                              p ¿Se emplazó la unidad?
                              br
                              button.button.is-primary.is-large.is-fullwidth(@click="guardarPuntos" v-show="!isEditado") Enviar
                              button.button.is-info.is-large.is-fullwidth(@click="guardarPuntos" v-show="isEditado") Actualizar
                            .column.is-2
                              .field
                                input#pg_emps.is-checkradio.is-danger(type='radio', value='1' v-model='veremplazado' disabled)
                                label.is-size-6(for='pg_emps') Si
                                input#pg_empn.is-checkradio.is-primary(type='radio', value='0' v-model='veremplazado', checked='checked' disabled)
                                label.is-size-6(for='pg_empn') No
</template>

<script>
import ModalInfo from '@/components/sca_Componentes/acceso/shared/ModalInfo.vue'
import autotanquesServicesIRGE from '@/services/irge/autotanquesIRGE.js'
import NavBarAccesos from '@/components/sca_Componentes/acceso/layout/NavBarAccesos.vue'
import Loader from '@/components/shared/Loader.vue'
import { mapState } from 'vuex'
import moment from 'moment'

export default {
  name: 'Puntos',
  components: { ModalInfo, NavBarAccesos, Loader },
  data () {
    return {
      idAcceso_Tanque: '',
      p1: '',
      p2: '',
      p3: '',
      p4: '',
      p5: '',
      p6: '',
      p7: '',
      p8: '',
      p9: '',
      p10: '',
      p11: '',
      p12: '',
      p13: '',
      p14: '',
      p15: '',
      p16: '',
      p17: '',
      p18: '',
      p19: '',
      p20: '',
      p21: '',
      p22: '',
      p23: '',
      observaciones: '',
      emplazado: '',
      modalStatus: false,
      contentModal: '',
      titleModal: '',
      verificadosCompletos: false,
      isLoading: true,
      isEditado: false
    }
  },
  methods: {
    iniciarComponente () {
      if (this.realizoFirma) {
        this.$store.commit('firmando', false)
        this.$router.push('/IRGE/Accesos')
      }
      autotanquesServicesIRGE.getPuntos_PG(this.tanqueActualSel.id)
        .then(res => {
          console.log(res)
          if (res.length > 0) {
            this.idAcceso_Tanque = res[0].id
            this.p1 = res[0].p1
            this.p2 = res[0].p2
            this.p3 = res[0].p3
            this.p4 = res[0].p4
            this.p5 = res[0].p5
            this.p6 = res[0].p6
            this.p7 = res[0].p7
            this.p8 = res[0].p8
            this.p9 = res[0].p9
            this.p10 = res[0].p10
            this.p11 = res[0].p11
            this.p12 = res[0].p12
            this.p13 = res[0].p13
            this.p14 = res[0].p14
            this.p15 = res[0].p15
            this.p16 = res[0].p16
            this.p17 = res[0].p17
            this.p18 = res[0].p18
            this.p19 = res[0].p19
            this.p20 = res[0].p20
            this.p21 = res[0].p21
            this.p22 = res[0].p22
            this.p23 = res[0].p23
            this.observaciones = res[0].observaciones
            this.emplazado = res[0].emplazado
          }
          
          this.isEditado = this.tanqueIsEditing

          setTimeout(() => {
            this.isLoading = false
          }, 250)
        })
    },
    guardarPuntos () {
      if (this.p1 === '' || this.p2 === '' || this.p3 === '' || this.p4 === '' || this.p5 === '' || this.p6 === '' || this.p7 === '' || this.p8 === '' || this.p9 === '' || this.p10 === '' || this.p11 === '' || this.p12 === '' || this.p13 === '' || this.p14 === '' || this.p15 === '' || this.p16 === '' || this.p17 === '' || this.p18 === '' || this.p19 === '' || this.p20 === '' || this.p21 === '' || this.p22 === '' || this.p23 === '' || this.emplazado === '') {
        console.log('algunos campos vacios')
        this.titleModal = 'Campos Vacios.'
        this.contentModal = '📝 Algunos campos están vacíos, debes revisar si todos los campos requeridos han sido llenados.'
        this.modalStatus = true
      } else {
        console.log('campos completos')
        this.titleModal = 'Guardando Información'
        this.contentModal = `Guardando información del autotanque: ${this.tanqueActualSel.pg}`
        this.modalStatus = true
        let ahora = moment().format('YYYY-MM-DD HH:mm:ss')
        let id_acceso_pg = Date.now()
        let horaEmplazado = ''
        if (this.emplazado === '1') {
          horaEmplazado = ahora
        } else {
          horaEmplazado = ''
        }

        autotanquesServicesIRGE.updatePG_acceso(this.idAcceso_Tanque, this.p1, this.p2, this.p3, this.p4, this.p5, this.p6, this.p7, this.p8, this.p9, this.p10, this.p11, this.p12, this.p13, this.p14, this.p15, this.p16, this.p17, this.p18, this.p19, this.p20, this.p21, this.p22, this.p23, this.emplazado, horaEmplazado, this.observaciones, '1')
          .then(res => {
            console.log(res)
            if (res.success) {
              // Update el Acceso
              autotanquesServicesIRGE.updateAcceso(this.tanqueActualSel.id, ahora, this.userLogin.id, this.userLogin.nombre)
                .then(resAcc => {
                  console.log(resAcc)
                  if (resAcc.success) {

                    if (this.emplazado === '1') {
                      let idPgEmp = Date.now()
                      autotanquesServicesIRGE.addPG_Emplazamiento(idPgEmp, ahora, this.tanqueActualSel.pg, this.observaciones, 0, 1, this.tanqueActualSel.id, this.userLogin.id)
                        .then(data => {
                          console.log(data)
                          if (data.success) {
                            let toast = this.$toasted.show(`Se Guardado el Emplazamiento del autotanque ${this.tanqueActualSel.pg} correctamente.`, { 
                              theme: "toasted-primary", 
                              position: "bottom-right", 
                              duration : 3000,
                              iconPack: 'fontawesome',
                              icon: 'check',
                              action : {
                                text : 'Ok',
                                onClick : (e, toastObject) => {
                                  toastObject.goAway(0)
                                }
                              },
                            })
                            
                            this.$store.commit('firmaPuntos', this.idAcceso_Tanque)
                            this.$router.push('/IRGE/Accesos/Firma')
                            
                          } else {
                            let toast = this.$toasted.show(`Error: ${data.respuesta}`, { 
                              theme: "toasted-primary", 
                              position: "bottom-right", 
                              duration : 3000,
                              iconPack: 'fontawesome',
                              icon: 'exclamation-circle',
                              action : {
                                text : 'Ok',
                                onClick : (e, toastObject) => {
                                  toastObject.goAway(0)
                                }
                              },
                            })
                          }
                        })
                    } else {
                      let toast = this.$toasted.show(`Se Guardado la información del autotanque ${this.tanqueActualSel.pg} correctamente.`, { 
                        theme: "toasted-primary", 
                        position: "bottom-right", 
                        duration : 3000,
                        iconPack: 'fontawesome',
                        icon: 'check',
                        action : {
                          text : 'Ok',
                          onClick : (e, toastObject) => {
                            toastObject.goAway(0)
                          }
                        },
                      })
                      this.$store.commit('firmaPuntos', this.idAcceso_Tanque)
                      this.$router.push('/IRGE/Accesos/Firma')
                    }
                  } else {
                    console.log(resAcc.respuesta)
                  }
                })
              setTimeout(() => {
                this.modalStatus = false
              }, 500)
            } else {
              console.log(res.respuesta)
            }
          })
      }
    },
    mandarEmplazar () {
      console.log('Mandar seccion de Emplazamiento')
    },
    cerrarModal () {
      this.modalStatus = false
    }
  },
  computed: {
    ...mapState(['tanqueActualSel', 'tanqueIsEditing', 'userLogin', 'realizoFirma']),
    veremplazado: function () {
      if (this.p1 === '0' || this.p2 === '0' || this.p3 === '0' || this.p4 === '0' || this.p8 === '0' || this.p9 === '0' || this.p10 === '0' || this.p11 === '0' || this.p12 === '0' || this.p13 === '0' || this.p14 === '0' || this.p15 === '0' || this.p16 === '0' || this.p17 === '0' || this.p18 === '0' || this.p19 === '0' || this.p20 === '1' || this.p21 === '0') {
        this.emplazado = '1'
        return '1'
      } else {
        this.emplazado = '0'
        return '0'
      }
    }
  },
  created () {
    this.iniciarComponente()
  },
}
</script>



// WEBPACK FOOTER //
// src/components/sca_Componentes/acceso/Puntos.vue